import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const userLoginService = (body) => {
  return realBricksApi.post(API_ENDPOINTS.AUTH.Login, body);
};

export const getUserProfileService = () => {
  return realBricksApi.get(API_ENDPOINTS.AUTH.Profile);
};

export const sendOtpService = (body) => {
  return realBricksApi.get(API_ENDPOINTS.AUTH.ReSendOtp, body);
};

export const verifyOtpService = (body) => {  
  return realBricksApi.post(API_ENDPOINTS.AUTH.ValidateOtp, body);
};
